// "Me" tab — account controls, Wall Mode entry, and logout.

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, List, ListItemButton, ListItemText, ListItemIcon,
  AppBar, Toolbar, Avatar, IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import InfoIcon from '@mui/icons-material/Info';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import AlexaEmailDialog, { alexaEmailCaption } from '../../shared/AlexaEmailDialog';
import { useApp } from '../../../core/state/AppContext';

export default function ProfileScreen() {
  const { user, logout } = useApp();
  const navigate = useNavigate();
  const [emailOpen, setEmailOpen] = useState(false);

  const fullName = user
    ? [user.Surname, user.Name, user.FatherHusband].filter(Boolean).join(' ')
    : '';

  return (
    <Box>
      <AppBar position="static" elevation={2}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate('/home')}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>Account Controls</Typography>
          <Box sx={{ width: 40 }} />
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar sx={{ bgcolor: 'primary.main' }}><PersonIcon /></Avatar>
        <Box>
          <Typography color="text.primary" fontWeight={600}>{fullName || 'User'}</Typography>
          <Typography color="text.secondary" variant="body2">{user?.MobileNumber}</Typography>
        </Box>
      </Box>

      <List>
        <ListItemButton onClick={() => setEmailOpen(true)}>
          <ListItemIcon sx={{ color: 'text.primary' }}><AlternateEmailIcon /></ListItemIcon>
          <ListItemText
            primary="Email"
            secondary={alexaEmailCaption(user)}
            primaryTypographyProps={{ color: 'text.primary' }}
          />
        </ListItemButton>
        <ListItemButton onClick={() => navigate('/wall')}>
          <ListItemIcon sx={{ color: 'text.primary' }}><DashboardIcon /></ListItemIcon>
          <ListItemText primary="Wall Mode" primaryTypographyProps={{ color: 'text.primary' }} />
        </ListItemButton>
        <ListItemButton onClick={() => navigate('/about')}>
          <ListItemIcon sx={{ color: 'text.primary' }}><InfoIcon /></ListItemIcon>
          <ListItemText primary="About" primaryTypographyProps={{ color: 'text.primary' }} />
        </ListItemButton>
        <ListItemButton onClick={() => { logout(); navigate('/login', { replace: true }); }}>
          <ListItemIcon sx={{ color: 'text.primary' }}><LogoutIcon /></ListItemIcon>
          <ListItemText primary="Logout" primaryTypographyProps={{ color: 'text.primary' }} />
        </ListItemButton>
      </List>
      <AlexaEmailDialog open={emailOpen} onClose={() => setEmailOpen(false)} />

      <Typography sx={{ textAlign: 'center', mt: 4 }} color="text.secondary" variant="caption">
        Adding new devices (Wi-Fi onboarding) is done in the Smart Life mobile app.
      </Typography>
    </Box>
  );
}
